export default __webpack_public_path__ + "static/media/moogle.986a568d.jpg";